import AssetInventoryRoute from "./AssetInventoryRoute";
import QuestionComponent from "../QuestionComponent";
import UsersComponent from '../UsersComponent';
import CreateNewAssessment from "../QuestionComponent/CreateNewAssessment";
import EditAssessmentQuestion from "../QuestionComponent/EditAssessmentQuestion";
import AuditDates from "../AuditDates";
import MergerAcquisitionScan from "../MergerAcquisitionScan";
import BlankPage from "client/Components/OrderManagement/BlankPage";
import AssetInventoryReadiness from "../AssetInventoryReadiness/AssetInventoryReadiness-container";

export interface routeType {
    path: string;
    component: any;
}

const AssetInventoryRouteOption: Array<routeType> = [
    {
        path:'/',
        component: UsersComponent
    },
    {
        path:'/questions',
        component:QuestionComponent
    },
    {
        path:'/questions/createnewassessment',
        component:CreateNewAssessment
    },
    {
        path:'/questions/editassessmentquestion',
        component:EditAssessmentQuestion
    },
    {
        path:'/auditdates',
        component:AuditDates
    },
    {
        path:'/mergerandacquisitionscan',
        component:MergerAcquisitionScan
    },
    {
        path:'/blank',
        component: BlankPage
    },
    {
        path:'/AssetInventoryReadiness',
        component: AssetInventoryReadiness
    }
]
const AssetInventoryRouteContainer = () =>{
    return <AssetInventoryRoute AssetInventoryRouteOption={AssetInventoryRouteOption}/>
}
export default AssetInventoryRouteContainer;
